import { render } from "./ThongKeSoLieu.vue?vue&type=template&id=e0a2f122&scoped=true&ts=true"
import script from "./ThongKeSoLieu.vue?vue&type=script&lang=ts"
export * from "./ThongKeSoLieu.vue?vue&type=script&lang=ts"

import "./ThongKeSoLieu.vue?vue&type=style&index=0&id=e0a2f122&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/KhamSucKhoe_NewVersion/KhamSucKhoe_FE_newVersion/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0a2f122"]])

export default __exports__